import styled from 'styled-components'

import closeIcon from '../../../assets/close.svg'

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 20px;
  height: 20px;
  border: none;
  background: url(${closeIcon}) center center no-repeat;
`
